import './btn';
import './checkbox';
import './radio';
import './input-text';
import './rounded';
import './paging';
import './scroll-pane';

import Utils from './utils';

const utils = new Utils();

window.UI = {
    // Utils
    utils,
};
